__turbopack_context__.v({
  "locked-resource-prompt": "h_rEoa_locked-resource-prompt",
  "locked-resource-prompt__actions": "h_rEoa_locked-resource-prompt__actions",
  "locked-resource-prompt__actions--secondary": "h_rEoa_locked-resource-prompt__actions--secondary",
  "locked-resource-prompt__content": "h_rEoa_locked-resource-prompt__content",
  "locked-resource-prompt__heading": "h_rEoa_locked-resource-prompt__heading",
  "locked-resource-prompt__lock-icon": "h_rEoa_locked-resource-prompt__lock-icon",
  "locked-resource-prompt__subheading": "h_rEoa_locked-resource-prompt__subheading",
});
